const CubeIcon = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M25.7733 7.57467L17.4133 3.06801C16.5333 2.58801 15.4667 2.58801 14.5867 3.06801L6.22666 7.57467C5.61332 7.90801 5.23999 8.54801 5.23999 9.28134C5.23999 10.0013 5.61332 10.6547 6.22666 10.988L14.5867 15.4947C15.0267 15.7347 15.52 15.8547 16 15.8547C16.48 15.8547 16.9733 15.7347 17.4133 15.4947L25.7733 10.988C26.3867 10.6547 26.76 10.0147 26.76 9.28134C26.76 8.54801 26.3867 7.90801 25.7733 7.57467Z"
                fill="#0CAE5C"
            />
            <path
                opacity="0.4"
                d="M13.2134 17.0535L5.42675 13.1602C4.82675 12.8669 4.13341 12.8935 3.57341 13.2402C3.00008 13.6002 2.66675 14.2002 2.66675 14.8669V22.2135C2.66675 23.4802 3.37341 24.6269 4.50675 25.2002L12.2801 29.0935C12.5707 29.2376 12.893 29.3058 13.217 29.2918C13.5411 29.2778 13.8563 29.1821 14.1334 29.0135C14.7067 28.6669 15.0401 28.0535 15.0401 27.3869V20.0402C15.0534 18.7602 14.3467 17.6135 13.2134 17.0535ZM28.4267 13.2402C27.8534 12.8935 27.1601 12.8535 26.5734 13.1602L18.8001 17.0535C17.6667 17.6269 16.9601 18.7602 16.9601 20.0402V27.3869C16.9601 28.0535 17.2934 28.6669 17.8667 29.0135C18.1438 29.1821 18.4591 29.2778 18.7831 29.2918C19.1072 29.3058 19.4295 29.2376 19.7201 29.0935L27.4934 25.2002C28.6267 24.6269 29.3334 23.4935 29.3334 22.2135V14.8669C29.3334 14.2002 29.0001 13.6002 28.4267 13.2402Z"
                fill="#0CAE5C"
            />
        </svg>
    );
};

export default CubeIcon;
